const state = {

    /** liste prepanier */
    StoreShowPrePanierListe: [],
    StorePrePanierFicheTechniqueStatus: [] ,
    StoreRefGerree: [] ,
    //pour comparer le pre panier actuel avec ceului lors de l'envoie d'un devis pour bloquer le btn
    StorePrePanierAddDevis: []

}
const mutations = {

    /** Lsite pre panier */
    SHOW_PRE_PANIER_LISTE(state, payload) {
      state.StoreShowPrePanierListe = payload;
    },
    /** Ajout au prePanier */
    ADD_PRE_PANIER_LISTE(state, payload) {
      state.StoreShowPrePanierListe.push(payload)
    },
    /** Ajout au prePanier */
    ADD_REF_GERREE(state, payload) {
      state.StoreRefGerree.push(payload)
    },
    /** Ajout au prePanier */
    ADD_PRE_PANIER_ADD_DEVIS(state, payload) {
      state.StorePrePanierAddDevis.push(payload)
    },
    /** Ajout au prePanier */
    ADD_FICHE_TECHNIQUE_STATUS(state, payload) {
      // // get the object key of the array
      // var key = Object.keys(payload)[0];
      // // get the object value of the array
      // var value = payload[key];
      // Vue.set(state.StorePrePanierFicheTechniqueStatus, key, value)
      state.StorePrePanierFicheTechniqueStatus.push(payload);
    },
    /** Ajout au prePanier */
    REMOVE_FICHE_TECHNIQUE_STATUS(state, payload) {
      const objWithIdIndex = state.StorePrePanierFicheTechniqueStatus.findIndex((obj) => obj === payload);
    
      if (objWithIdIndex > -1) {
        state.StorePrePanierFicheTechniqueStatus.splice(objWithIdIndex, 1);
      }
    },
    /** Suppression ligne au prePanier */
    DELETE_PRE_PANIER_LISTE(state, payload) {

        const objWithIdIndex = state.StoreShowPrePanierListe.findIndex((obj) => obj.id_perso === payload);
      
        if (objWithIdIndex > -1) {
          state.StoreShowPrePanierListe.splice(objWithIdIndex, 1);
        }
      
    },
    /** Maj prePanier */
    MAJ_PRE_PANIER_LISTE(state, payload ) {

     var idtab = payload.id_perso;
     var value = payload.value;
     var libelle = payload.libelle_tab;
     
     var upd_obj = state.StoreShowPrePanierListe.findIndex((obj) => obj.id_perso === idtab) ;
      state.StoreShowPrePanierListe[upd_obj]['pa_'+libelle] = value ;

    },
    MAJ_PRE_PANIER_LISTE_NO_PA(state, payload ) {

     var idtab = payload.id_perso;
     var value = payload.value;
     var libelle = payload.libelle_tab;
     
     var upd_obj = state.StoreShowPrePanierListe.findIndex((obj) => obj.id_perso === idtab) ;
      state.StoreShowPrePanierListe[upd_obj][libelle] = value ;

    },

}
export default {
    state,
    mutations,
}